import React, {Component} from 'react';
import {NavLink} from 'components/ReactRouterDomLocalized';

import FollowForm from './FollowForm';

import paths from 'paths';

import '../../../sass/headers/header.scss';

import {t, dt} from 'l10n';

class HeaderFollow extends Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    render() {
        let {title, showForm = true} = this.props;

        return (
            <header className="follow-header">
                <div className="content">
                    <h1>{title}</h1>
                    <div className="text-follow-header">
                        {showForm && <FollowForm/>}

                        <div className="choose-follow">
                            <NavLink to={paths.memberFollowing.path} className="choose-f" activeClassName="active">
                                <span>{t('Followees')}</span>
                            </NavLink>
                            <NavLink to={paths.memberFollowers.path} className="choose-f" activeClassName="active">
                                <span>{t('Followers')}</span>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}

export default HeaderFollow;


// WEBPACK FOOTER //
// ./src/containers/member/follow/HeaderFollow.js